<div class='type-liens'>
  @for (type of TYPES_LIENS_VISUELS; track type) {
    <div class="element" (click)='selectType(type)' [class]="type.iconClass">
      <i [class]="'icon icon-' + type.iconClass"></i>
      <p>{{type.libelle}}</p>
    </div>
  }
</div>
